import { useEffect, useState } from "react";
import { getFormData } from "../../../common/FormUtil";
import { createEducation, deleteEducation, updateEducation } from "../../../repository/RealEstateRepository";
import { RealEstateMap } from "./";
import { getEduColor, getEduMarker } from "./EducationMapRenderer";

const EducationMap = (props) => {
  const [basePoint, setBasePoint] = useState(null);
  const [baseMarker, setBaseMarker] = useState(null);
  const [educationMarkers, setEducationMarkers] = useState([]);
  const [markers, setMarkers] = useState([]);
  const [selectedMarker, setSelectedMarker] = useState(null);

  // base-markers
  useEffect(() => {
    if (!basePoint) return;
    setBaseMarker({ ...basePoint });
  }, [basePoint]);

  // edu-markers
  useEffect(() => {
    if (!props.educations) return;
    const _edu = props.educations;
    setEducationMarkers([_edu.middleSchools, _edu.elementarySchools, _edu.academyStreets].flatMap(v => v).map(v => ({
      ...v,
      icon: getEduMarker(v),
      onClick: (e) => {
        setSelectedMarker({
          dataset: e.overlay.dataset
        });
      }
    })));
  }, [props.educations]);

  useEffect(() => {
    const markers = [].concat(educationMarkers);
    if (baseMarker) markers.push(baseMarker);
    setMarkers(markers);
  }, [baseMarker, educationMarkers]);

  return (<>
    <RealEstateMap
      markers={markers}
      onInit={props.onChangeMap}
      onIdle={props.onChangeMap}
      onClick={(e) => setBasePoint({ latitude: e.latlng.lat(), longitude: e.latlng.lng() })} />

    <div style={{ position: "absolute", left: 4, top: 56 + 4 }}>
      {selectedMarker == null && (<>
        <EducationCreateForm
          basePoint={basePoint}
          reloadEducations={props.reloadEducations} />
      </>)}
      {selectedMarker != null && (<>
        <EducationUpdateForm
          detail={selectedMarker.dataset}
          reloadEducations={props.reloadEducations}
          onClickClose={() => setSelectedMarker(null)} />
      </>)}
    </div>
  </>);
};

const EducationCreateForm = (props) => {
  const { basePoint, reloadEducations } = props;
  const [selectedType, setSelectedType] = useState(null);

  const onChangeEducationType = (e) => {
    setSelectedType(e.target.value);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const formData = getFormData(e.target);
    createEducation(formData, () => {
      reloadEducations();
      window.Toast.info("Education Created.");
      e.target.name.value = "";
    });
  };

  return (<>
    <div style={{ width: 240, padding: 10, border: "1px solid #000", background: "#fff" }}>
      <form onSubmit={onSubmit}>
        <select name="educationType" className="form-control form-control-sm fluid" style={{ background: getEduColor(selectedType) }} onChange={onChangeEducationType}>
          <option value="">EducationType</option>
          <option value="MIDDLE_SCHOOL">중학교</option>
          <option value="ELEMENTARY_SCHOOL">초등학교</option>
          <option value="ACADEMY_STREET">학원가</option>
        </select>
        {selectedType && (<>
          <input name="name" className="form-control form-control-sm fluid" placeholder="Name" />
          {selectedType === "MIDDLE_SCHOOL" && (<>
            <input name="score" className="form-control form-control-sm fluid" placeholder="AverageScore" />
            <input name="specializedHeadcount" className="form-control form-control-sm fluid" placeholder="SpecializedHeadcount" />
          </>)}
          {selectedType === "ELEMENTARY_SCHOOL" && (<>
            <input name="headcount" className="form-control form-control-sm fluid" placeholder="Headcount" />
          </>)}
          {selectedType === "ACADEMY_STREET" && (<>
            <input name="academyCount" className="form-control form-control-sm fluid" placeholder="Count" />
          </>)}
          <div className="form-group">
            <input name="" className="form-control form-control-sm fluid text-center" value={[basePoint ? basePoint.latitude : "-", basePoint ? basePoint.longitude : "-"].join(", ")} readOnly />
            <input name="latitude" type="hidden" value={basePoint ? basePoint.latitude : ""} readOnly />
            <input name="longitude" type="hidden" value={basePoint ? basePoint.longitude : ""} readOnly />
          </div>
          <div>
            <button type="submit" className="btn btn-sm btn-primary" disabled={(!selectedType)}>Create</button>
          </div>
        </>)}
      </form>
    </div>
  </>);
};

const EducationUpdateForm = (props) => {
  const detail = props.detail;
  const [onLoad, setOnLoad] = useState(false);

  useEffect(() => {
    setOnLoad(false);
    setTimeout(() => setOnLoad(true));
  }, [props.detail]);

  const onClickDelete = (e) => {
    e.preventDefault();
    const answer = window.confirm("Are you sure?");
    if (answer) {
      const formData = getFormData(e.target.form);
      deleteEducation(formData, () => {
        window.Toast.warning("Environment Deleted.");
        props.reloadEducations();
        props.onClickClose();
      });
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const formData = getFormData(e.target);
    updateEducation(formData, () => {
      window.Toast.info("Environment Updated.");
      props.reloadEducations();
    });
  };

  const onClickClose = (e) => {
    e.preventDefault();
    props.onClickClose();
  };

  const selectedType = detail.type;

  return (<>
    <div style={{ width: 220, padding: 10, border: "1px solid #000", background: "#fff" }}>
      {onLoad && (<>
        <form onSubmit={onSubmit}>
          <input name="id" type="hidden" className="fluid" value={detail.id} readOnly />
          <input name="educationType" className="form-control-plaintext form-control-sm fluid" value={detail.type} style={{ textIndent: "1em" }} readOnly />
          <input name="name" className="form-control form-control-sm fluid" placeholder="Name" defaultValue={detail.name} />
          {selectedType === "MIDDLE_SCHOOL" && (<>
            <input name="score" className="form-control form-control-sm fluid" placeholder="AverageScore" defaultValue={detail.score} />
            <input name="specializedHeadcount" className="form-control form-control-sm fluid" placeholder="SpecializedHeadcount" defaultValue={detail.specializedHeadcount} />
          </>)}
          {selectedType === "ELEMENTARY_SCHOOL" && (<>
            <input name="headcount" className="form-control form-control-sm fluid" placeholder="Headcount" defaultValue={detail.headcount} />
          </>)}
          {selectedType === "ACADEMY_STREET" && (<>
            <input name="academyCount" className="form-control form-control-sm fluid" placeholder="Count" defaultValue={detail.academyCount} />
          </>)}
          <div className="form-group">
            <input name="" className="form-control form-control-sm fluid text-center" value={[detail ? detail.latitude : "-", detail ? detail.longitude : "-"].join(", ")} readOnly />
            <input name="latitude" type="hidden" value={detail ? detail.latitude : ""} readOnly />
            <input name="longitude" type="hidden" value={detail ? detail.longitude : ""} readOnly />
          </div>
          <div>
            <button className={"btn btn-sm btn-danger"} onClick={onClickDelete}>Delete</button>
            &nbsp;<button type="submit" className="btn btn-sm btn-primary">Update</button>
            &nbsp;<button className={"btn btn-sm btn-light"} onClick={onClickClose}>Close</button>
          </div>
        </form>
      </>)}
    </div>
  </>);
};

export { EducationMap };
